import React, { useEffect, useRef } from "react";
import { languageHelper } from "../../config/helperFunctions";

function DefaultInvoice({ logo, general, data, invoice, handlePrint, currencySetting }) {
  const defaultLang =
    invoice.invoice_lang === "default"
      ? localStorage.getItem("rms-lang") || "text_en"
      : invoice.invoice_lang === "Arabic"
      ? "text_ar"
      : "text_en";
  const date = new Date();
  const invoiceRef = useRef(null);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${day}-${month}-${year}`;
  let currentDateSlash = `${month}/${day}/${year}`;

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  let currentTime = `${hours}:${minutes}:${seconds}`;

  let vatAmount = data.vat_amount - data.tobaco_vat;

  function formatDate(inputDate) {
    // Split date and time
    const [date] = inputDate.split(" ");
    // Split year, month, and day
    const [year, month, day] = date.split("-");
    // Return formatted date as MM/DD/YYYY
    return `${month}/${day}/${year}`;
  }

  const apiUrl = window.RUNTIME_API_URL;
  const hostname = new URL(apiUrl).hostname;

  const isChangePadding = hostname.includes("sahnew");
  const paddingClass = isChangePadding ? "pr-32" : "pr-8";

  useEffect(() => {
    handlePrint("Default Invoice", invoiceRef);
  }, [handlePrint]);

  return (
    <>
      {/* for sahnew pr-32 */}
      <div
        ref={invoiceRef}
        className={`w-full max-w-5xl mx-auto py-8 pl-8 ${paddingClass}`}
      >
        {/* <div ref={invoiceRef} className="w-full max-w-5xl mx-auto py-8 pl-8 pr-8"> */}
        <img src={logo} className="mx-auto w-32" alt="" />
        <h1 className="text-4xl font-medium text-center mt-6">
          {general.restaurant_name}
        </h1>
        <div className="text-center text-2xl mt-2">
          <p>{general.address}</p>
          <p>
            {languageHelper("Tel", defaultLang)}: {general.phone}
          </p>
          {/* <p>(24-11-04-000166)</p> */}
          <p>({`${currentDate}-${data.token_no}`})</p>
        </div>

        <p className="text-2xl text-center mt-4">
          {languageHelper("Invoice No", defaultLang)}: {data.sale_no}
        </p>
        <div className="flex justify-between gap-4 mt-16 text-lg">
          <div>({Number(data.token_no)})</div>
          <div className="text-end">
            <p>
              {languageHelper("Order Type", defaultLang)}:{" "}
              {data.order_type?.type}
            </p>
            <p>
              {languageHelper("Cutomer Name", defaultLang)}:{" "}
              {data.is_guest === "no" ? data.customer?.name : data.guest?.name}
            </p>
            {data.order_type_id === 2 && (
              <p>
                {languageHelper("Cutomer Number", defaultLang)}:{" "}
                {data.is_guest === "no"
                  ? data.customer?.phone
                  : data.guest?.phone}
              </p>
            )}
            <p>
              {languageHelper("Cashier Name", defaultLang)}:{" "}
              {data.cashier?.name}
            </p>
          </div>
        </div>
        <div className="flex justify-between text-xl font-medium mt-4">
          <p className="px-4">
            {languageHelper("Selling Point", defaultLang)}: 1
          </p>
          <p className="px-4">
            {languageHelper("Sales Associate", defaultLang)}: Admin
          </p>
        </div>
        <table className="w-full text-xl">
          <thead>
            <tr className="border-b-2 border-t-2 border-dotted border-black">
              <th colSpan={2} className="py-1 whitespace-nowrap text-start">
                {languageHelper("Name", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Qty", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Item Price", defaultLang)}
              </th>
              <th className="py-1 text-end">
                {languageHelper("Price", defaultLang)}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.order_details?.map((orderItem, index) => (
              <>
                <tr
                  key={index}
                  className={
                    orderItem.modifiers.length === 0 &&
                    `border-b-2 border-black border-dotted`
                  }
                >
                  <td colSpan={2}>
                    <p>
                      {orderItem.name} / {orderItem.name_arabic}
                    </p>
                  </td>
                  <td>{orderItem.qty}</td>
                  <td>{orderItem.menu_unit_price.toFixed(2)}</td>
                  <td className="py-2 px-4 text-end">
                    {orderItem.menu_unit_price_with_vat.toFixed(2) ===
                    orderItem.menu_price_with_discount.toFixed(2) ? (
                      <p>
                        {orderItem.menu_unit_price_with_vat.toFixed(2) *
                          orderItem.qty}
                      </p>
                    ) : (
                      <span className="flex gap-2">
                        <p className="line-through">
                          {orderItem.menu_unit_price_with_vat.toFixed(2) *
                            orderItem.qty}
                        </p>
                        <p>
                          {orderItem.menu_price_with_discount.toFixed(2) *
                            orderItem.qty}
                        </p>
                      </span>
                    )}
                  </td>
                </tr>
                {orderItem.food_menu.is_deal === "yes" && (
                  <tr>
                    <td colSpan={5}>
                      {orderItem.food_menu.deal_details &&
                        JSON.parse(orderItem.food_menu.deal_details)?.map(
                          (deal, index) => (
                            <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                          )
                        )}
                    </td>
                  </tr>
                )}
                {orderItem.modifiers.map((mod, index) => (
                  <tr
                    key={index}
                    className={
                      orderItem.modifiers.length === index + 1 &&
                      `border-b-2 border-black border-dotted`
                    }
                  >
                    <td colSpan={2}>{mod.name}</td>
                    <td colSpan={2}>{mod.pivot.qty}</td>
                    <td className="text-end">{mod.price * mod.pivot.qty}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
          <tbody className="font-medium">
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={4}>{languageHelper("Total", defaultLang)}</td>
              <td>{(data.sub_total + data.vat_amount).toFixed(2)}</td>
              <td>{currencySetting.value || "S.R"} </td>
            </tr>
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={4}>{languageHelper("Sub Total", defaultLang)}</td>
              <td>{data.sub_total.toFixed(2)}</td>
              <td>{currencySetting.value || "S.R"} </td>
            </tr>
            {data.total_discount_amount !== 0 && (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={4}>{languageHelper("Discount", defaultLang)}</td>
                <td>{data.total_discount_amount.toFixed(2)}</td>
                <td>{currencySetting.value || "S.R"} </td>
              </tr>
            )}
            {data.delivery_charges !== 0 && (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={4}>
                  {languageHelper("Service/Delivery", defaultLang)}
                </td>
                <td>{data.delivery_charges.toFixed(2)}</td>
                <td>{currencySetting.value || "S.R"} </td>
              </tr>
            )}
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={4}>{languageHelper("VAT", defaultLang)}</td>
              <td>{vatAmount.toFixed(2)}</td>
              <td>{currencySetting.value || "S.R"} </td>
            </tr>
            {data.tobaco_vat !== 0 && (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={4}>
                  {languageHelper("Tobacco Tax 100%", defaultLang)}
                </td>
                <td>{data.tobaco_vat}</td>
                <td>{currencySetting.value || "S.R"} </td>
              </tr>
            )}
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={4}>{languageHelper("Grand Total", defaultLang)}</td>
              <td>{data.total_payable}</td>
              <td>{currencySetting.value || "S.R"} </td>
            </tr>
          </tbody>
          <tbody>
            {data.payment.name === "Multi Cash" ? (
              data.multiple_payments.map((payments, index) =>
                payments.company_name === "Cash" ? (
                  <>
                    <tr
                      key={index}
                      className="border-b-2 border-black border-dotted"
                    >
                      <td colSpan={4}>{payments.company_name}</td>
                      <td>{payments.amount}</td>
                      <td>{currencySetting.value || "S.R"} </td>
                    </tr>
                    <tr
                      key={index}
                      className="border-b-2 border-black border-dotted"
                    >
                      <td colSpan={4}>
                        {languageHelper("Total Paid (Cash)", defaultLang)}
                      </td>
                      <td>{payments.amount}</td>
                      <td>{currencySetting.value || "S.R"} </td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr key={index} className="">
                      <td colSpan={4}>
                        {languageHelper("Credit Card", defaultLang)}
                      </td>
                      <td>{payments.amount}</td>
                      <td>{currencySetting.value || "S.R"} </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        {languageHelper("Input Method", defaultLang)}
                      </td>
                      <td>{languageHelper("Terminal", defaultLang)}</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        {languageHelper("Card Company", defaultLang)}
                      </td>
                      <td>{payments.company_name}</td>
                    </tr>
                    <tr className="border-b-2 border-t-2">
                      <td colSpan={3}>
                        {languageHelper("Certified Amount", defaultLang)}
                      </td>
                      <td>{payments.amount}</td>
                    </tr>
                  </>
                )
              )
            ) : data.payment.name === "Cash" ? (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={4}>{data.payment.name}</td>
                <td>{data.total_payable}</td>
                <td>{currencySetting.value || "S.R"} </td>
              </tr>
            ) : (
              <>
                <tr>
                  <td colSpan={4}>
                    {languageHelper("Credit Card", defaultLang)}
                  </td>
                  <td>{data.total_payable}</td>
                  <td>{currencySetting.value || "S.R"} </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    {languageHelper("Input Method", defaultLang)}
                  </td>
                  <td>{languageHelper("Terminal", defaultLang)}</td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    {languageHelper("Card Company", defaultLang)}
                  </td>
                  <td>{data.payment.name}</td>
                </tr>
                <tr className="border-b-2 border-t-2">
                  <td colSpan={4}>
                    {languageHelper("Certified Amount", defaultLang)}
                  </td>
                  <td>{data.total_payable}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>

        <div className="text-center text-xl space-y-4 mt-4">
          {invoice.invoice_footer && <p>{invoice.invoice_footer}</p>}
          {invoice.invoice_footer1 && <p>{invoice.invoice_footer1}</p>}
          {invoice.invoice_footer2 && <p>{invoice.invoice_footer2}</p>}
        </div>
        <div className="text-xl">
          {invoice.order_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Order Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.statement_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Statement Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.print_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Print Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{currentDateSlash}</p>
                <span>{currentTime}</span>
              </div>
            </div>
          )}
        </div>
        <div>
          <img
            src={data.qr_image_base64 || data.qr_image_url}
            className="w-64 mx-auto mt-4"
            alt=""
          />
          <p className="text-2xl mt-16 text-center font-bold">
            QR
          </p>
        </div>
      </div>
    </>
  );
}

export default DefaultInvoice;
